import React from 'react';
import Header from './Header';
import Footer from './Footer';
import usePageMeta from '../seo/usePageMeta';
import './Datenschutz.css';

const Datenschutz=()=>{
  usePageMeta({
    title:'Datenschutzerklärung | Cura Care GmbH',
    description:'Informationen zum Datenschutz auf der Website der Cura Care GmbH in Eitorf.',
    path:'/datenschutz'
  });

  return(
    <div className="page-view">
      <Header/>

      <div className="legal-page">
        <main className="legal-card">
          <h1 className="legal-title">Datenschutzerklärung</h1>

          <section className="legal-section">
            <h2>1. Name und Kontaktdaten des für die Verarbeitung Verantwortlichen</h2>
            <p>Diese Datenschutz-Information gilt für die Datenverarbeitung durch:</p>
            <p>
              <strong>Cura Care GmbH</strong><br/>
              Bahnhofstraße 19<br/>
              53783 Eitorf
            </p>
            <p>
              Telefon: <a href="tel:+4922438455323">02243 8455323</a><br/>
              E-Mail:{' '}
              <a href="mailto:info@curacare-pflegedienst.de">
                info@curacare-pflegedienst.de
              </a>
            </p>
            <p>
              Vertreten durch die Geschäftsführung:{' '}
              <strong>Ayfer Evmez</strong>
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung</h2>
            <p>
              Beim Aufrufen unserer Website <strong>curacare-pflegedienst.de</strong> werden durch den auf Ihrem
              Endgerät zum Einsatz kommenden Browser automatisch Informationen an den Server unserer Website gesendet.
              Diese Informationen werden temporär in einem sog. Logfile gespeichert. Folgende Informationen werden dabei
              ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:
            </p>
            <ul>
              <li>IP-Adresse des anfragenden Rechners,</li>
              <li>Datum und Uhrzeit des Zugriffs,</li>
              <li>Name und URL der abgerufenen Datei,</li>
              <li>Website, von der aus der Zugriff erfolgt (Referrer-URL),</li>
              <li>
                verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers.
              </li>
            </ul>
            <p>Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:</p>
            <ul>
              <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website,</li>
              <li>Gewährleistung einer komfortablen Nutzung unserer Website,</li>
              <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
              <li>zu weiteren administrativen Zwecken.</li>
            </ul>
            <p>
              Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Unser berechtigtes
              Interesse folgt aus den oben aufgelisteten Zwecken zur Datenerhebung. In keinem Fall verwenden wir die
              erhobenen Daten zu dem Zweck, Rückschlüsse auf Ihre Person zu ziehen.
            </p>
            <p>
              Wenn Sie uns per E-Mail kontaktieren oder unser Kontaktformular auf der Website nutzen, verarbeiten wir die von Ihnen
              übermittelten Daten (z.B. Name, E-Mail-Adresse, Telefonnummer, Inhalte Ihrer Nachricht) zum Zweck der Bearbeitung
              Ihres Anliegens und für den Fall von Anschlussfragen. Die Angaben können insbesondere sein:
            </p>
            <ul>
              <li>Ihr Name,</li>
              <li>Ihre E-Mail-Adresse,</li>
              <li>Ihre Telefonnummer (freiwillig),</li>
              <li>der Inhalt Ihrer Nachricht.</li>
            </ul>
            <p>
              Die Verarbeitung der über das Kontaktformular übermittelten Daten erfolgt auf Grundlage von Art. 6 Abs. 1 S. 1 lit. b
              DSGVO (Vertragsanbahnung/-durchführung), soweit es um ein Pflege- oder Betreuungsverhältnis geht, im Übrigen auf
              Grundlage von Art. 6 Abs. 1 S. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).
              Soweit Sie uns im Freitextfeld freiwillig weitergehende Informationen mitteilen, erfolgt die Verarbeitung auf
              Grundlage Ihrer Einwilligung gem. Art. 6 Abs. 1 S. 1 lit. a DSGVO.
            </p>
            <p>
              Die im Zusammenhang mit einer Kontaktaufnahme anfallenden Daten werden gelöscht, sobald sie für die Zweckerfüllung
              (Bearbeitung Ihrer Anfrage) nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>

            <p>
              Cookies, die einer Einwilligung bedürfen, sowie Analysedienste setzen wir nicht ein. Nähere
              Erläuterungen dazu erhalten Sie unter den Ziff. 4 und 5 dieser Datenschutzerklärung.
            </p>
            <section className="legal-section">
              <h3>Kontaktformular</h3>
              <p>
                Auf unserer Website stellen wir ein Kontaktformular zur Verfügung. Die Nutzung dieses Formulars ist freiwillig.
                Zur Bearbeitung Ihrer Anfrage sind bestimmte Angaben erforderlich (Pflichtfelder), weitere Angaben können Sie
                freiwillig machen.
              </p>
              <p>
                Pflichtangaben sind Ihr Name, Ihre E-Mail-Adresse und Ihre Zustimmung zu dieser Datenschutzerklärung.
                Freiwillig sind Telefonnummer, die Angabe, wann Sie am besten erreichbar sind, und Ihre Nachricht.
              </p>
              <p>
                Beim Absenden werden Ihre Angaben an einen Serverdienst von uns übermittelt (Google Cloud Functions,
                Rechenzentrum Frankfurt am Main), dort geprüft und in unserer Datenbank (Google Cloud Firestore)
                gespeichert. Von dort erhalten wir eine Benachrichtigung per E-Mail, und unser Team ruft die Anfrage in
                einem passwortgeschützten internen Bereich ab. Einzelheiten finden Sie im Abschnitt
                „Kontaktformular und Speicherung der Anfragen“ unter Ziff. 6.
              </p>
              <p>
                Eine Weitergabe der Daten an sonstige Dritte findet nicht statt, es sei denn, wir sind hierzu gesetzlich
                verpflichtet oder Sie haben ausdrücklich eingewilligt.
              </p>
              <p>
                Bitte übermitteln Sie über das Kontaktformular grundsätzlich keine besonders sensiblen Informationen
                (z.B. detaillierte Gesundheitsdaten). Für die pflegerische Versorgung und Dokumentation gelten gesonderte
                Informations- und Einwilligungsunterlagen, die wir Ihnen im Rahmen der Vertragsanbahnung zur Verfügung stellen.
              </p>
            </section>

          </section>

          <section className="legal-section">
            <h2>3. Weitergabe von Daten</h2>
            <p>
              Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden aufgeführten Zwecken
              findet nicht statt.
            </p>
            <p>Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:</p>
            <ul>
              <li>Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrückliche Einwilligung dazu erteilt haben,</li>
              <li>
                die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Geltendmachung, Ausübung oder Verteidigung von
                Rechtsansprüchen erforderlich ist und kein Grund zu der Annahme besteht, dass Sie ein überwiegendes
                schutzwürdiges Interesse an der Nichtweitergabe Ihrer Daten haben,
              </li>
              <li>
                für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche
                Verpflichtung besteht sowie
              </li>
              <li>
                dies gesetzlich zulässig und nach Art. 6 Abs. 1 S. 1 lit. b DSGVO für die Abwicklung von
                Vertragsverhältnissen mit Ihnen erforderlich ist.
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Cookies und lokale Speicherung</h2>
            <p>
              Unsere Website setzt keine Cookies ein, die eine Einwilligung erfordern, und verwendet keine
              Tracking- oder Werbe-Cookies.
            </p>
            <p>
              Lediglich im passwortgeschützten internen Verwaltungsbereich (Anmeldung für das Team) werden
              technisch notwendige Daten zum Anmeldestatus im lokalen Speicher Ihres Browsers abgelegt.
              Rechtsgrundlage ist § 25 Abs. 2 Nr. 2 TDDDG in Verbindung mit Art. 6 Abs. 1 S. 1 lit. f DSGVO.
            </p>
          </section>
          

          <section className="legal-section">
            <h2>5. Webanalyse</h2>
            <p>
              Wir setzen keine Webanalyse- oder Statistikdienste (etwa Google Analytics oder Matomo) ein.
              Es werden keine Nutzungsprofile erstellt.
            </p>
          </section>
          
          <section className="legal-section">
            <h2>6. Hosting und E-Mail-Versand</h2>
            <p>
              Unsere Website wird bei einem externen Dienstleister gehostet. Ebenso nutzen wir die Infrastruktur von externen
              Dienstleistern für den Versand und Empfang von E-Mails (z.B. info@curacare-pflegedienst.de).
            </p>

            <h3>Hosting über Firebase</h3>
            <p>
              Das Hosting unserer Website erfolgt über den Dienst &bdquo;Firebase Hosting&ldquo;, einen Dienst der Google Ireland
              Limited, Gordon House, Barrow Street, Dublin 4, Irland (&bdquo;Google&ldquo;).
            </p>
            <p>
              Beim Besuch unserer Website werden Verbindungsdaten (z.B. IP-Adresse, Datum und Uhrzeit des Abrufs, Informationen
              zum verwendeten Browser und Betriebssystem) durch Google in unserem Auftrag verarbeitet, um die Website
              auszuliefern und die Sicherheit und Stabilität des Betriebs zu gewährleisten. Rechtsgrundlage hierfür ist Art. 6
              Abs. 1 S. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und effizienten Bereitstellung unseres
              Online-Angebots).
            </p>
            <p>
              Soweit hierbei eine Übermittlung personenbezogener Daten in Drittländer (insbesondere in die USA) stattfindet,
              erfolgt diese auf Basis des Angemessenheitsbeschlusses der EU-Kommission zum EU-US Data Privacy
              Framework, nach dem die Google LLC zertifiziert ist (Art. 45 DSGVO), sowie ergänzend der von der
              EU-Kommission verabschiedeten Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO).
            </p>

            <h3>E-Mail-Versand über STRATO</h3>
            <p>
              Für den Versand und Empfang von E-Mails (z.B. info@curacare-pflegedienst.de, datenschutz@curacare-pflegedienst.de)
              nutzen wir die Server unseres E-Mail- bzw. Hosting-Anbieters STRATO AG, Deutschland.
            </p>
            <p>
              STRATO verarbeitet die hierbei anfallenden Kommunikationsdaten (z.B. Absender, Empfänger, Uhrzeit, Meta-Daten,
              ggf. Inhalte) ausschließlich in unserem Auftrag und nach unseren Weisungen. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1
              lit. f DSGVO (berechtigtes Interesse an einer sicheren und zuverlässigen E-Mail-Kommunikation). Mit STRATO haben
              wir einen Vertrag über Auftragsverarbeitung nach Art. 28 DSGVO geschlossen.
            </p>
            <h3>Kontaktformular und Speicherung der Anfragen (Google Cloud Firestore)</h3>
            <p>
              Wenn Sie uns über das Kontaktformular schreiben, werden die von Ihnen eingegebenen Daten (Name,
              E-Mail-Adresse, gegebenenfalls Telefonnummer, Erreichbarkeit und Nachricht sowie Datum und Uhrzeit) über
              den Dienst &bdquo;Cloud Functions&ldquo; in der Datenbank &bdquo;Cloud Firestore&ldquo; der Google Ireland
              Limited gespeichert. Beide Dienste betreiben wir im Rechenzentrum Frankfurt am Main. Anschließend wird
              eine Benachrichtigung per E-Mail an unser Postfach gesendet. Wir verwenden die Daten ausschließlich zur
              Bearbeitung Ihrer Anfrage und für eventuelle Anschlussfragen.
            </p>
            <p>
              Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. b DSGVO (Anbahnung eines Vertrags) beziehungsweise
              Art. 6 Abs. 1 S. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen). Die Daten
              werden gelöscht, sobald sie für die Bearbeitung nicht mehr erforderlich sind und keine gesetzlichen
              Aufbewahrungspflichten entgegenstehen. Bitte übermitteln Sie über das Formular keine Gesundheitsdaten.
            </p>
            <p>
              <strong>Schutz vor Missbrauch:</strong> Um automatisierte Massenanfragen (Spam) zu verhindern, begrenzen
              wir die Zahl der Anfragen je Absender. Dazu wird Ihre IP-Adresse nicht im Klartext gespeichert, sondern
              nur als nicht rückrechenbarer Prüfwert (Hashwert) zusammen mit einem Zähler, der nach etwa einem Tag
              automatisch gelöscht wird. Zusätzlich prüfen wir, wie lange das Ausfüllen gedauert hat, und werten ein für
              Menschen unsichtbares Formularfeld aus. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO (berechtigtes
              Interesse an einem sicheren, missbrauchsfreien Betrieb des Kontaktformulars).
            </p>

            <h3>Google-Bewertungen auf der Startseite</h3>
            <p>
              Auf unserer Startseite zeigen wir die Sternebewertung und einzelne Rezensionen aus unserem
              Unternehmensprofil bei Google. Diese Inhalte ruft unser Serverdienst (Google Cloud Functions,
              Rechenzentrum Frankfurt am Main) über die Schnittstelle &bdquo;Places API&ldquo; der Google Ireland
              Limited ab und speichert sie nur kurzzeitig zwischen. Ihr Browser baut dabei keine Verbindung zu Google
              Maps auf, und es werden keine Daten über Sie an Google übermittelt. Profilbilder der Verfasserinnen und
              Verfasser binden wir nicht ein.
            </p>
            <p>
              Die angezeigten Namen sind mit den öffentlichen Google-Profilen der Verfasser verlinkt. Erst wenn Sie
              einen dieser Links oder &bdquo;Alle Bewertungen auf Google ansehen&ldquo; anklicken, gelangen Sie zu Google,
              und Google verarbeitet Ihre Daten nach eigenen Bestimmungen. Rechtsgrundlage für die Darstellung ist
              Art. 6 Abs. 1 S. 1 lit. f DSGVO (berechtigtes Interesse an einer transparenten Darstellung von
              Kundenerfahrungen).
            </p>

            <h3>Schriftarten</h3>
            <p>
              Die auf dieser Website verwendeten Schriftarten werden lokal von unserem Server ausgeliefert. Es
              findet keine Verbindung zu Servern von Google Fonts oder anderen Schriftanbietern statt.
            </p>

            <h3>Google Maps (nur nach Ihrer Zustimmung)</h3>
            <p>
              Auf der Kontaktseite bieten wir eine Karte von Google Maps an. Die Karte wird erst geladen, wenn Sie
              auf &bdquo;Google Maps laden&ldquo; klicken. Erst dann werden Daten (unter anderem Ihre IP-Adresse) an
              die Google Ireland Limited übertragen; Google kann diese Daten auch in die USA übermitteln.
              Rechtsgrundlage ist Ihre Einwilligung nach Art. 6 Abs. 1 S. 1 lit. a DSGVO. Ohne Zustimmung können
              Sie die Route über einen Link öffnen, der Sie direkt zu Google Maps führt. Weitere Informationen:{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                https://policies.google.com/privacy
              </a>.
            </p>
          </section>


          <section className="legal-section">
            <h2>7. Social Media</h2>
            <p>
              Wir binden keine Social-Media-Plug-ins ein. Auf unserer Website befindet sich lediglich ein Link zu
              unserem Instagram-Profil. Erst wenn Sie diesen Link anklicken, verlassen Sie unsere Website und es
              werden Daten an Instagram (Meta Platforms Ireland Limited) übertragen. Informationen zum Datenschutz
              bei Instagram finden Sie unter{' '}
              <a href="https://privacycenter.instagram.com/policy" target="_blank" rel="noreferrer">
                https://privacycenter.instagram.com/policy
              </a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Betroffenenrechte</h2>
            <p>Sie haben das Recht:</p>
            <ul>
              <li>
                gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen.
                Insbesondere können Sie Auskunft über die Verarbeitungszwecke, die Kategorien personenbezogener Daten,
                die Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder werden, die geplante
                Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung der Verarbeitung oder
                Widerspruch, das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde, die Herkunft Ihrer Daten,
                sofern diese nicht bei uns erhoben wurden, sowie über das Bestehen einer automatisierten
                Entscheidungsfindung einschließlich Profiling und ggf. aussagekräftige Informationen zu deren
                Einzelheiten verlangen;
              </li>
              <li>
                gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns
                gespeicherten personenbezogenen Daten zu verlangen;
              </li>
              <li>
                gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen,
                soweit nicht die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information, zur
                Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur
                Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;
              </li>
              <li>
                gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen,
                soweit die Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber
                deren Löschung ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese zur Geltendmachung,
                Ausübung oder Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO Widerspruch gegen
                die Verarbeitung eingelegt haben;
              </li>
              <li>
                gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem
                strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen
                anderen Verantwortlichen zu verlangen;
              </li>
              <li>
                gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen. Dies
                hat zur Folge, dass wir die Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft
                nicht mehr fortführen dürfen; und
              </li>
              <li>
                gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren. In der Regel können Sie sich hierfür
                an die Aufsichtsbehörde Ihres üblichen Aufenthaltsortes, Ihres Arbeitsplatzes oder unseres
                Unternehmenssitzes wenden.
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Widerspruchsrecht</h2>
            <p>
              Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1
              lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die
              Verarbeitung Ihrer personenbezogenen Daten einzulegen, soweit dafür Gründe vorliegen, die sich aus Ihrer
              besonderen Situation ergeben oder sich der Widerspruch gegen Direktwerbung richtet. Im letzteren Fall
              haben Sie ein generelles Widerspruchsrecht, das ohne Angabe einer besonderen Situation von uns umgesetzt
              wird.
            </p>
            <p>
              Möchten Sie von Ihrem Widerrufs- oder Widerspruchsrecht Gebrauch machen, genügt eine E-Mail an:{' '}
              <a href="mailto:info@curacare-pflegedienst.de">
                info@curacare-pflegedienst.de
              </a>
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Datensicherheit</h2>
            <p>
              Wir bedienen uns geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre Daten gegen
              zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung oder gegen
              den unbefugten Zugriff Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der
              technologischen Entwicklung fortlaufend verbessert.
            </p>
            <p>
              Die Verbindung zu unserer Website ist durchgehend per TLS verschlüsselt. Sie erkennen dies an
              &bdquo;https://&ldquo; und dem Schloss-Symbol in der Adresszeile Ihres Browsers.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Aktualität und Änderung dieser Datenschutzerklärung</h2>
            <p>
              Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Oktober 2026. Durch die
              Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter gesetzlicher beziehungsweise
              behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle
              Datenschutzerklärung kann jederzeit auf der Website unter{' '}
              <strong>curacare-pflegedienst.de</strong> von Ihnen abgerufen und ausgedruckt werden.
            </p>
          </section>

          <hr/>

          <section className="legal-section">
            <h2>Informationen zu Datenverarbeitung und zur Schweigepflicht</h2>
            <p>
              Aufgrund der Vorgaben der EU-Datenschutzgrundverordnung (DSGVO) haben Sie ein weitreichendes
              Informationsrecht zur Verarbeitung Ihrer personenbezogenen Daten im Rahmen der Pflege und Betreuung durch
              unseren ambulanten Pflegedienst. Die Verarbeitung erfolgt dabei für unterschiedliche Zwecke. Nachfolgend
              informieren wir Sie darüber, um welche Datenverarbeitungen es sich handelt, auf welcher Rechtsgrundlage
              sie stattfinden und welche Rechte Ihnen zustehen.
            </p>
            <p>Vorab möchten wir Ihnen folgende Begriffe näher erläutern:</p>
            <p>
              <strong>Datenverarbeitung:</strong> Jeder Umgang mit personenbezogenen Daten, wie das Erheben, Erfassen,
              die Speicherung, das Nutzen, die Übermittlung an Dritte einschließlich eines Offenlegens sowie die
              Löschung.
            </p>
            <p>
              <strong>Stammdaten:</strong> Allgemeine Daten zur Person, wie z.B. Name, Adresse, Geburtsdatum, Geburtsort
              sowie ggf. Daten Ihrer Vertreter und/oder ggf. Ihrer Angehörigen.
            </p>
            <p>
              <strong>Pflege- und Betreuungsdaten:</strong> Daten, die sich speziell auf die Pflege und Betreuung
              beziehen, wie z.B. pflegerische Ist-Analysen, Einschätzungen zu besonderen pflegerischen Risiken,
              medizinische Informationen, Diagnosen, Arztbriefe und andere Befunde, Allergien, Gewicht, Größe,
              Vitalwerte, Wunddokumentationen, Vorlieben bei den Beschäftigungen.
            </p>
            <p>
              <strong>Abrechnungsdaten:</strong> Die Daten, die der Pflegedienst zur Abrechnung der erbrachten Leistungen
              benötigt, wie z.B. Rechnungsempfänger und Adresse, Bankverbindung, Daten zur Krankenkasse und zur
              Pflegekasse sowie die in Anspruch genommenen Leistungen.
            </p>
          </section>

          <section className="legal-section">
            <h2>1. Verarbeitungszwecke und Rechtsgrundlagen für die Verarbeitung</h2>

            <h3>a) Datenverarbeitung zu Zwecken der Anbahnung und des Abschlusses eines Pflegevertrags</h3>
            <p>
              Zur Anbahnung und zum Abschluss eines Pflegevertrags werden in unserem Pflegedienst die Stammdaten der
              (zukünftigen) Patient:innen bzw. ggf. auch ihrer Vertreter:innen verarbeitet.
            </p>
            <p>Rechtsgrundlage: Art. 9 Abs. 2 lit. h DSGVO, § 22 Abs. 1 Nr. 1 lit. b BDSG.</p>

            <h3>
              b) Datenverarbeitung zur Erbringung der pflegerischen und betreuerischen Leistungen sowie von
              hauswirtschaftlichen Leistungen und Beratung
            </h3>
            <p>
              Zur Erbringung unserer Leistungen (z.B. in Pflege, Betreuung, Hauswirtschaft und Beratung) verarbeiten
              unsere angestellten und ggf. ehrenamtlichen Mitarbeiter:innen Stammdaten sowie Pflege- und
              Betreuungsdaten der Patient:innen. Teilweise werden einzelne Leistungen auch durch Kooperationspartner
              übernommen, die unserer Weisung unterliegen.
            </p>
            <p>Rechtsgrundlage: Art. 9 Abs. 2 lit. h DSGVO, § 22 Abs. 1 Nr. 1 lit. b BDSG.</p>
            <p>
              Bestimmte pflegerische Leistungen wie z.B. Blutzuckermessen, Verbandswechsel und Arzneimittelgabe werden
              auf Anordnung der behandelnden Ärzt:innen erbracht (sog. medizinische Behandlungspflege). Die für die
              Anordnung und Durchführung jeweils erforderlichen Daten werden zwischen dem Pflegedienst und den
              behandelnden Ärzt:innen ausgetauscht und gespeichert.
            </p>
            <p>Rechtsgrundlage: Art. 9 Abs. 2 lit. h DSGVO, § 22 Abs. 1 Nr. 1 lit. b BDSG.</p>
            <p>
              Darüber hinaus informieren sich unser ambulanter Pflegedienst und die ärztlichen Behandler:innen
              (Hausarztpraxen, Fachärzt:innen, Kliniken) sowie die nichtärztlichen Behandler:innen (z.B.
              Physiotherapeut:innen, Ergotherapeut:innen, medizinische Fußpfleger:innen) gegenseitig über ihre
              Feststellungen und Maßnahmen, soweit dies für eine gute Versorgung und Behandlung erforderlich ist. Eine
              entsprechende Abstimmung erfolgt auch zwischen unserem ambulanten Pflegedienst und weiteren an der Pflege
              und Betreuung beteiligten Diensten und Einrichtungen (z.B. Tagespflegeeinrichtungen, stationäre
              Einrichtungen, Palliative Care Teams).
            </p>
            <p>
              Rechtsgrundlage: Art. 9 Abs. 2 lit. a DSGVO (Einwilligung) – in medizinischen oder pflegerischen
              Notfällen ist die wechselseitige Information auch ohne Einwilligung zulässig, Art. 9 Abs. 2 lit. c DSGVO.
            </p>

            <h3>c) Datenverarbeitung zu Zwecken der Abrechnung</h3>
            <p>
              Ihre abrechnungsrelevanten Daten werden zur Erstellung der Abrechnung der von uns erbrachten Leistungen
              verarbeitet und an den jeweiligen Rechnungsempfänger übermittelt.
            </p>
            <p>Rechtsgrundlage: Art. 9 Abs. 2 lit. h DSGVO, § 22 Abs. 1 Nr. 1 lit. b BDSG.</p>
            <p>Rechnungsempfänger sind außer Ihnen oder der von Ihnen beauftragten Person insbesondere:</p>
            <ul>
              <li>
                die gesetzlichen Krankenkassen für die Abrechnung der häuslichen Krankenpflege und Haushaltshilfe bei
                gesetzlich Versicherten<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. h, Abs. 4 DSGVO, §§ 294, 302 SGB V
              </li>
              <li>
                die gesetzlichen Pflegekassen für die Abrechnung der Pflege- und Betreuungsleistungen, der
                hauswirtschaftlichen Leistungen und der Beratungseinsätze bei gesetzlich Versicherten<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. h, Abs. 4 DSGVO, §§ 104 Abs. 1, 105 SGB XI
              </li>
              <li>
                ggf. sonstige Kostenträger wie z.B. Beihilfestellen, private Pflegeversicherungen, Versorgungsämter,
                Unfallversicherungen oder Sozialämter, sofern Sie in eine entsprechende Abrechnung eingewilligt haben<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. a DSGVO (Einwilligung)
              </li>
            </ul>

            <h3>d) Datenverarbeitung zur Wahrung von Rechtsansprüchen</h3>
            <p>
              Unser ambulanter Pflegedienst darf Ihre Daten auch verarbeiten, wenn dies zur Geltendmachung, Ausübung
              oder Verteidigung von Rechtsansprüchen erforderlich ist.
            </p>
            <p>
              Rechtsgrundlage: Art. 9 Abs. 2 lit. f DSGVO. Dies betrifft insbesondere die Datenverarbeitung
              zur Beitreibung offener Forderungen (gerichtliche Geltendmachung, einschließlich Einschaltung von
              Rechtsberater:innen, Mahnverfahren, Klageerhebung) und zur Verteidigung gegen Schadensersatz- und
              Rückforderungsansprüche, einschließlich Einschaltung unserer Haftpflichtversicherung, sowie zur Anzeige
              von Straftaten oder zur Verteidigung gegen strafrechtliche Vorwürfe.
            </p>

            <h3>
              e) Datenverarbeitung zu Zwecken der Qualitätssicherung und -kontrolle und zur Erfüllung sozialrechtlicher
              Pflichten
            </h3>
            <p>
              Die Qualität der Leistungserbringung und der Abrechnung im ambulanten Pflegedienst wird durch interne wie
              externe Prüfverfahren und Kontrollen überprüft. Auch hierfür werden personenbezogene Daten von
              Patient:innen verarbeitet, soweit dies hierfür erforderlich ist.
            </p>
            <ul>
              <li>
                Qualitätsprüfungen durch den Medizinischen Dienst und Prüfdienste der Kostenträger<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. i, Abs. 3 DSGVO, § 114 SGB XI, § 275b SGB V
              </li>
              <li>
                Rechnungsprüfung, Controlling, Wirtschaftsprüfung durch einrichtungsinterne oder von uns beauftragte
                Prüfer<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. h, Abs. 3 DSGVO, § 22 Abs. 1 Nr. 1 lit. b BDSG
              </li>
              <li>
                Abrechnungs- und Wirtschaftlichkeitsprüfungen durch die gesetzlichen Krankenkassen und Pflegekassen<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. h, Abs. 3 DSGVO, u.a. §§ 275b, 302 SGB V, §§ 79, 104 SGB XI
              </li>
              <li>
                interne Qualitätssicherungsmaßnahmen sowie Qualitätssicherungsmaßnahmen durch beauftragte
                externe Prüfer:innen/Auditor:innen<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. h, Abs. 3 DSGVO, § 22 Abs. 1 Nr. 1 lit. b BDSG
              </li>
            </ul>

            <h3>f) Sozialrechtliche Auskunfts- und Informationspflichten</h3>
            <p>
              Unseren ambulanten Pflegedienst treffen ggf. sozialrechtliche Auskunfts- und Informationspflichten, z.B.:
            </p>
            <ul>
              <li>
                gegenüber dem Medizinischen Dienst, wenn dieser den Pflegegrad eines Pflegekunden in einem
                Pflegebegutachtungsverfahren überprüft – wir sind dann verpflichtet, die erforderlichen Auskünfte zu
                erteilen und notwendige Unterlagen vorzulegen<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. h, Abs. 3 DSGVO, § 18 Abs. 5 SGB XI
              </li>
              <li>
                gegenüber der gesetzlichen Pflegekasse, wenn Präventions- oder Reha-Maßnahmen erforderlich sind, sich
                der Pflegebedarf geändert hat oder beim Beratungseinsatz Möglichkeiten zur Verbesserung der häuslichen
                Pflegesituation festgestellt wurden<br/>
                Rechtsgrundlage: Art. 9 Abs. 2 lit. a DSGVO, § 106a SGB X, § 10 Rahmenvertrag gem. § 75 SGB XI
                (Einwilligung erforderlich)
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>2. Erhebung der Daten</h2>
            <p>
              Die erforderlichen Daten erhebt unser ambulanter Pflegedienst soweit möglich bei Ihnen selbst. Teilweise
              erhalten wir Daten aber auch direkt von Ihren behandelnden Ärzt:innen und Therapeut:innen oder von
              Krankenhäusern, Rehakliniken und Pflegeeinrichtungen, die Sie vor oder während unserer Vertragsbeziehung
              betreuen. Auch von Angehörigen und Bezugspersonen erhalten wir manchmal ergänzende Informationen. Diese
              Daten werden bei uns im Sinne einer einheitlichen Dokumentation mit Ihren übrigen Daten zusammengeführt.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Aufbewahrungsdauer</h2>
            <p>
              Die Dauer der Aufbewahrung richtet sich nach verschiedenen Rechtsgrundlagen, die unterschiedliche
              Aufbewahrungsfristen vorsehen. So sind u.a. aus Gründen der Beweissicherung in Haftungsfällen, der
              Abrechnung und Sicherung unserer Ansprüche sowie aufgrund der Vorgaben der ordnungsgemäßen Buchführung
              unterschiedliche Fristen maßgebend. Spätestens nach 30 Jahren werden Ihre Daten gelöscht, sofern keine
              gesetzlichen Gründe für eine längere Aufbewahrung bestehen.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Hinweis auf die berufliche Schweigepflicht</h2>
            <p>
              Ihre Daten werden in unserem Unternehmen verarbeitet. Die mit der Datenverarbeitung befassten
              Mitarbeiter:innen unterliegen entweder bereits kraft Gesetzes oder aufgrund einer entsprechenden
              Verpflichtung durch den Arbeitgeber einer beruflichen Schweigepflicht, die der des Arztes vergleichbar
              ist. Wird diese Schweigepflicht verletzt, kann dies eine Strafbarkeit nach § 203 Strafgesetzbuch (StGB)
              nach sich ziehen.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Rechte auf Auskunft, Berichtigung, Löschung usw.</h2>
            <p>
              Ihnen stehen die in der DSGVO vorgesehenen Betroffenenrechte zu (siehe oben Ziff. 7), also insbesondere
              das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch und
              Datenübertragbarkeit. Diese Rechte können Sie gegenüber Cura Care als Träger des ambulanten Pflegedienstes
              geltend machen.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Beschwerderecht bei der Aufsichtsbehörde wegen Datenschutzverstößen</h2>
            <p>
              Sie haben auch das Recht auf Beschwerde bei der zuständigen Datenschutzaufsichtsbehörde, wenn Sie der
              Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten datenschutzrechtlich nicht zulässig ist.
              Dies ergibt sich aus Art. 77 DSGVO. Die Beschwerde bei der Aufsichtsbehörde kann formlos erfolgen.
            </p>
            <p>
              Für uns zuständig ist die Landesbeauftragte für Datenschutz und Informationsfreiheit
              Nordrhein-Westfalen, Kavalleriestraße 2–4, 40213 Düsseldorf,{' '}
              <a href="https://www.ldi.nrw.de" target="_blank" rel="noreferrer">www.ldi.nrw.de</a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Datenschutzbeauftragter des ambulanten Pflegedienstes</h2>
            <p>Unser ambulanter Pflegedienst hat einen Datenschutzbeauftragten bestellt. Seine Kontaktdaten lauten:</p>
            <p>
              <strong>Max Pelz</strong><br/>
              Datenschutzbeauftragter Cura Care GmbH<br/>
              Bahnhofstraße 19 · 53783 Eitorf<br/>
              E-Mail:{' '}
              <a href="mailto:datenschutz@curacare-pflegedienst.de">
                datenschutz@curacare-pflegedienst.de
              </a>
            </p>
            <p>Bei Fragen stehen wir Ihnen gerne zur Verfügung.</p>
          </section>

          <hr/>

          <section className="legal-section">
            <h2>Hinweisgeberschutzgesetz (HinSchG) – Interne Meldestelle bei Cura Care</h2>
            <p>
              Zur Prävention von Schäden durch unverantwortliche oder illegale Handlungen wurde das
              Hinweisgeberschutzgesetz (HinSchG) eingeführt. Hierfür haben wir eine interne Meldestelle eingerichtet.
            </p>
            <p>
              Diese interne Meldestelle ist zuständig für die Meldung von Informationen oder begründeten
              Verdachtsmomenten zu begangenen oder bevorstehenden Gesetzesverstößen bei Cura Care. Hierzu zählen
              insbesondere Straftaten, Ordnungswidrigkeiten und Verstöße gegen ausgewähltes Bundes-, Landes- und/oder
              EU-Recht (§ 2 Abs. 1 HinSchG).
            </p>
            <p>Themen aus den folgenden Bereichen können Gegenstand einer Meldung sein:</p>
            <ul>
              <li>Verletzung von Rechten oder dem Schutz von Personen</li>
              <li>Verletzung des Schutzes personenbezogener Daten</li>
              <li>Diskriminierung oder Belästigung</li>
              <li>Betrug oder Unterschlagung</li>
              <li>Finanzkriminalität, Manipulation in der Rechnungslegung</li>
              <li>Bestechung und Korruption</li>
              <li>Umweltschäden</li>
              <li>Verstöße in Bezug auf Gesundheit, Arbeitssicherheit und Betriebssicherheit</li>
              <li>sonstiges unangemessenes, illegales oder unethisches Verhalten</li>
            </ul>
            <p>
              Die interne Meldestelle behandelt Meldungen vertraulich. Ohne Ihre Zustimmung wird Ihre Identität nicht
              offengelegt. Sie können Meldungen über Gesetzesverstöße auch anonym abgeben.
            </p>
            <p>
              Sie erreichen die interne Meldestelle per E-Mail unter:{' '}
              <a href="mailto:info@curacare-pflegedienst.de">
                info@curacare-pflegedienst.de
              </a>
            </p>
            <p>
              Verantwortlich für die interne Meldestelle bei Cura Care ist aktuell:{' '}
              <strong>Max Pelz</strong>.
            </p>
          </section>
        </main>
      </div>

      <Footer/>
    </div>
  );
};

export default Datenschutz;
